.anchor {
  display: inline-flex;
  max-width: 100%;
}

.tooltip {
  z-index: var(--z-tooltip);
  display: flex;
  align-items: center;
  gap: var(--space-2);
  max-width: 280px;
  padding: 5px 8px;
  border-radius: var(--radius-sm);
  background: var(--surface-inverse);
  color: var(--text-inverse);
  font-size: var(--text-sm);
  line-height: 1.3;
  box-shadow: var(--shadow-md);
  pointer-events: none;
  animation: fade-in var(--duration-fast) var(--ease);
}

.shortcut > kbd {
  border-color: transparent;
  background: rgb(127 127 127 / 0.3);
  color: inherit;
}

.pointer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: var(--z-tooltip);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
  color: var(--text);
  font-size: var(--text-sm);
  box-shadow: var(--shadow-md);
  pointer-events: none;
  will-change: transform;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
}
